// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__DhUkX","title":"Info_title__Rga3T","links":"Info_links__26OEt","link":"Info_link__2n2B_","logo":"Info_logo___f4mq"};